"use strict";

import $ from 'jquery';
import swal from 'sweetalert';

import Messages from '../common/Messages';
import Wizard from '../common/QuestionWizard';
import AccountChangeRequestService, {AccountChangeType} from '../endpoints/AccountChangeRequestService';
import SportParticipationService from '../endpoints/SportParticipationService';
import AccountSettingsSection from './AccountSettingsSection';
import BasicInformationSection, {Events, eventBus as BasicInformationEventBus} from './BasicInformationSection';
import SportParticipationSection from './SportParticipationSection';
import ContactInformationSection from '../account/ContactInformationFormHandler';
import TermsAndConditionsSection from './TermsAndConditionsSection';
import {toISODateString} from '../common/Utils';
import {ensureValidCsrfToken} from '../endpoints/Urls';

let _accountSettingsWizard;

function handleOnStepChanging(currentStep, newIndex){
    // Clean up if user went backward before
    let newStep = $(_accountSettingsWizard.steps[newIndex].target);

    if (currentStep.index < newIndex)
    {
        // To remove error styles
        newStep.find('label.error').remove();
        newStep.find('.error').removeClass("error");
    }
    
}

function mapToModel(){
    let accountForm = $('#account-settings-form');
    let basicInfoForm = $('#basic-information-form');
    let contactForm = $('#contact-form');
    let termsForm = $('#terms-form');

    return {
        //account Settings
        email : accountForm.find('[name=edit-email]').val(),
        securityQuestionKey : accountForm.find('[name=securityQuestionKey]').val(),
        securityAnswer : accountForm.find('[name=securityAnswer]').val(),
        password : accountForm.find('[name=edit-password]').val(),
        //Basic Settings
        firstName : basicInfoForm.find('[name=firstName]').val(),
        middleName : basicInfoForm.find('[name=middleName]').val(),
        lastName : basicInfoForm.find('[name=lastName]').val(),
        accountSubType : basicInfoForm.find('[name=accountSubType]:checked').val(),
        ethnicityCodes : basicInfoForm.find('[name=ethnicityCodes]:checked').map(function(i, item){
            return $(item).val();
        }).toArray(),
        genderCode : basicInfoForm.find('[name=genderCode]:checked').val(),
        dateOfBirthString : toISODateString(basicInfoForm.find('[name=dateOfBirthString]').val()),
        graduationDateString : basicInfoForm.find('[name=graduationDateString]').val(),
        enrollmentDateString : basicInfoForm.find('[name=enrollmentDateString]').val(),
        parent1RelationType : basicInfoForm.find('[name=parent1RelationType]').val(),
        parent1EducationType : basicInfoForm.find('[name=parent1EducationType]').val(),
        parent2RelationType : basicInfoForm.find('[name=parent2RelationType]').val(),
        parent2EducationType : basicInfoForm.find('[name=parent2EducationType]').val(),
        //contact info
        address1 : contactForm.find('[name=address1]').val(),
        address2 : contactForm.find('[name=address2]').val(),
        city : contactForm.find('[name=city]').val(),
        countryCode : contactForm.find('[name=countryCode]').val(),
        stateCode : contactForm.find('[name=stateCode]').val(),
        postalCode : contactForm.find('[name=postalCode]').val(),
        phone : contactForm.find('[name=phone]').val(),
        alternatePhone : contactForm.find('[name=alternatePhone]').val(),
        contactName : contactForm.find('[name=contactName]').val(),
        contactPhone : contactForm.find('[name=contactPhone]').val(),
        contactEmail : contactForm.find('[name=contactEmail]').val(),
        studentLegalSignature : termsForm.find('[name=accept-bylaw]').is(':checked'),
        parentLegalSignature  : termsForm.find('[name=parental-consent]').is(':checked') ? true : null
    };
}

function addSportParticipation(){
    let sportCodes = $('#sport-participation-form').find('[name="sportsParticipation"]');
    let sports = sportCodes.map(function(i, item){
        return $(item).val();
    }).toArray(); 

    let chainedResults = Promise.resolve(true);

    $.each(sports, (i, sportCode) => {
        chainedResults = chainedResults.then(() => {
            return SportParticipationService.addSport(sportCode);
        });
    });

    return chainedResults;
}

function handleFinish(){
    //the code validation that happens on the first account settings page caches the StudentAccountChangeRequestDTO when it is valid
    let model = $('#account-settings-form').data('change-request');

    model.studentDTO = mapToModel();

    let performChange =  AccountChangeRequestService.performChange(model);

    // for profile accounts, add the sports as sports participation after the account is created
    if (model.changeRequestType === AccountChangeType.CREATE_PROFILE_ACCOUNT) {
        performChange = performChange
            .then(() => ensureValidCsrfToken(true))
            .then(() => {return addSportParticipation();});
    }
    _accountSettingsWizard.toggleFinishButton(false);
/******************************** START: SSO login - post account creation *********************************/
// 2023_01_05: SSO application has implemented a CSRF protection attack, so we cannot submit hidden form
// to log in users after account creation automatically; users will need to enter the credentials
// through the SSO login page to log in after the account creation.
/*
    // Submit SSO hidden form after student account creation to authenticate the user against the CAS server.
    // On successful authentication, a SSO session cookie(TGT) is set on the browser.
    // When user attempts to access NCAA College Basketball Academy application, CAS server will validate
    // the SSO session cookie(TGT) available in the browser and grant access to the
    // application without prompting the user to login.
    performChange
    .then(() => {
        $('#username').val(model.studentDTO.email);
        $('#password').val(model.studentDTO.password);
        $('#sso_form').submit();
    })
    .catch(function(){
        swal({
            title: "Error",
            text: `We were unable to complete your request. ${Messages.CONTACT_SUPPORT}`,
            type: "error",
            confirmButtonText: "Ok" });

        _accountSettingsWizard.toggleFinishButton(true);
    });
*/
    performChange
        .then(() => {
            window.location.href = window.logOutUrl;
        })
        .catch(function(){
            swal({
                title: "Error",
                text: `We were unable to complete your request. ${Messages.CONTACT_SUPPORT}`,
                type: "error",
                confirmButtonText: "Ok" });

            _accountSettingsWizard.toggleFinishButton(true);
        });
    /******************************** END: SSO login - post account creation *********************************/
}

document.addEventListener("DOMContentLoaded", function() {

    let containerSelector = '#account';

    _accountSettingsWizard = new Wizard(
        {
            selector : containerSelector,
            stepValidation : {
                'accountsettings' : AccountSettingsSection.validate,
                'basicinformation' : BasicInformationSection.validate,
                'contact' : ContactInformationSection.validate,
                'sportsparticipation' : SportParticipationSection.validate,
                'terms' : TermsAndConditionsSection.validate
            }
        }
    );

    //attach event handler
    _accountSettingsWizard.addListener('StepChanging', handleOnStepChanging);
    _accountSettingsWizard.addListener('Finish', handleFinish);

    //usability Set focus on the first form element when the tab is shown
    _accountSettingsWizard.addListener('StepChanged', function(e){
        $(e.current.target).find('input, select').filter(':first').trigger('focus');
    });

    AccountSettingsSection.wireup();
    BasicInformationSection.wireup();
    ContactInformationSection.wireup();
    SportParticipationSection.wireup();
    TermsAndConditionsSection.wireup();

    BasicInformationEventBus.addListener(Events.DOB_CHANGED, TermsAndConditionsSection.handleDateOfBirthChange);
});


// WEBPACK FOOTER //
// /mnt/appdata/jenkins/jobs/EC_Registration/workspace/web/app/~/eslint-loader!./js/register/complete-registration-page.js